import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reports-sharing-center-deleted', {
        url: '/reports/sharing-center/deleted',
        component: 'sharingCenterDeletedReport',
        resolve: {accounts}
    });
}

/** @ngInject */
function accounts( companyId, SharedAccountsService) {
    return SharedAccountsService
        .getDeletedByCompany({companyId}).$promise;

}


// WEBPACK FOOTER //
// ./src/portal/states/company/reports/sharing-center-reports/sharing-center-deleted-report/sharing-center-deleted-report.state.js